import {
	IconActivity,
	IconAdjustments,
	IconAdjustmentsHorizontal,
	IconAlertTriangle,
	IconCoin,
	IconHome,
	IconKey,
	IconMessageChatbot,
	IconMessages,
	IconPlugConnected,
	IconRobot,
	IconSettings,
	IconShieldCheck,
	IconShieldLock,
	IconUsers,
} from "@tabler/icons-react";
import type { AdminNavItem } from "./admin-nav.logic";

/**
 * Katalog menu sidebar panel admin, berikut kunci izinnya. Satu tempat untuk
 * pasangan menu↔fitur: kunci yang sama dipakai guard endpoint di server, jadi
 * menu yang tampil di sini selalu punya penegakannya sendiri.
 *
 * "Beranda" sengaja TANPA kunci — selalu tampil bagi siapa pun yang boleh
 * membuka /admin, supaya tidak ada admin yang mendarat di sidebar kosong.
 */

/** Teks menu Server Log mengikuti bahasa UI, jadi dilewatkan dari pemanggil. */
export interface ServerLogNavText {
	label: string;
	description: string;
}

export function buildAdminNavItems(
	serverLog: ServerLogNavText,
): AdminNavItem[] {
	return [
		{
			icon: IconHome,
			label: "Beranda",
			to: "/admin",
			description: "Ringkasan sistem & statistik",
		},
		{
			icon: IconUsers,
			label: "Pengguna",
			to: "/admin/users",
			description: "Kelola akun & hak akses",
			feature: "admin-users",
		},
		{
			icon: IconKey,
			label: "API Key",
			to: "/admin/apikey",
			description: "Manajemen kunci akses API",
			feature: "admin-apikey",
		},
		{
			icon: IconShieldCheck,
			label: "Audit Log",
			to: "/admin/audit-log",
			description: "Riwayat aktivitas semua pengguna",
			feature: "admin-audit-log",
		},
		{
			icon: IconShieldLock,
			label: "Role & Permission",
			to: "/admin/roles",
			description: "Konfigurasi hak akses per role pengguna",
			feature: "admin-roles",
		},
		{
			icon: IconActivity,
			label: "System Health",
			to: "/admin/system-health",
			description: "Status konektivitas dan latency komponen sistem",
			feature: "admin-system-health",
		},
		{
			icon: IconAlertTriangle,
			label: serverLog.label,
			to: "/admin/server-log",
			description: serverLog.description,
			feature: "admin-server-log",
		},
		{
			icon: IconRobot,
			label: "Jenna AI",
			description: "Pengaturan asisten AI Jenna",
			children: [
				{
					icon: IconAdjustmentsHorizontal,
					label: "Umum",
					to: "/admin/ai-assistant/umum",
					description: "Nama, saklar, batas pemakaian & suara Jenna",
					feature: "admin-ai-umum",
				},
				{
					icon: IconPlugConnected,
					label: "Penyedia AI",
					to: "/admin/ai-assistant/penyedia",
					description: "Mode penyedia, failover & kredensial per fitur",
					feature: "admin-ai-penyedia",
				},
				{
					icon: IconMessageChatbot,
					label: "Persona",
					to: "/admin/ai-assistant/persona",
					description: "Gaya bicara, aturan & logo Jenna",
					feature: "admin-ai-persona",
				},
				{
					icon: IconCoin,
					label: "Pemakaian & Biaya",
					to: "/admin/ai-assistant/pemakaian",
					description: "Ringkasan hari ini, plafon & tarif model",
					feature: "admin-ai-pemakaian",
				},
				{
					icon: IconMessages,
					label: "Log Percakapan",
					to: "/admin/ai-assistant/log",
					description: "Siapa bertanya apa, dijawab model mana",
					feature: "admin-ai-log",
				},
			],
		},
		{
			icon: IconSettings,
			label: "Pengaturan",
			to: "/admin/settings",
			description: "Konfigurasi sistem",
			feature: "admin-settings",
		},
		{
			icon: IconAdjustments,
			label: "Preferensi",
			to: "/admin/preferences",
			description: "Bahasa, zona waktu & tampilan dashboard",
			feature: "admin-preferences",
		},
	];
}
